export default __webpack_public_path__ + "static/media/closeIcon.999fa470.svg";